import UsableGifts from '../../components/pages/mypages/UsableGifts.vue'
export default {
  components: { UsableGifts }
}
